
const hideTheHouse = shouldHide => {
    const $homeBase = document.getElementById('nuStationHomeBase');
    if($homeBase) {
        if (shouldHide) {
            $homeBase.classList.add('animated', 'fadeOut');
            $homeBase.classList.remove('fadeIn');
        } else {
            $homeBase.classList.remove('fadeOut');
            $homeBase.classList.add('animated', 'fadeIn');
        }
    } else {
        setTimeout(() => hideTheHouse(shouldHide), 1000);
    }
};

export default hideTheHouse;
